import { Modal, PrimaryButton } from '@cb/apricot-react'
import { Error, Spinner } from '@myap/ui-library'
import { useEffect } from 'react'
import useUserSettingsQuery from '../../../../hooks/useUserSettingsQuery'
import useStudentJoinCourseDetailsQuery from '../../hooks/useStudentJoinCourseDetailsQuery'
import useStudentSectionDetailsQuery from '../../hooks/useStudentSectionDetailsQuery'
import useStudentEnrollmentsQuery from '../../hooks/useStudentEnrollmentsQuery'
import useStudentAddEnrollmentMutation from '../../hooks/useStudentAddEnrollmentMutation'
import { useAnalyticsStudentRegSuccessEvent } from '../../../../hooks/analyticsHooks'

import styles from '../joincourse.module.scss'

function Message({ courseName, error, loading, success }) {
  if (error) {
    return <Error title="Error enrolling" message={error} />
  }

  if (loading) {
    return (
      <div className={styles['save-loader']}>
        <Spinner spinnerId="joinSpinner" size="64" ariaLabel="Saving..." />
      </div>
    )
  }

  if (success) {
    return (
      <div className={styles.save}>
        You&#39;ve enrolled in
        <br />
        {courseName}!
      </div>
    )
  }

  return null
}

function FooterActions({ busy }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <PrimaryButton disabled={busy} loading={busy} data-cb-modal-close={true}>
        Close
      </PrimaryButton>
    </div>
  )
}

function SaveEnrollment() {
  // Get user details
  const {
    educationPeriod: { code: educationPeriod },
  } = useUserSettingsQuery()
  const { data: joinCourseData } = useStudentJoinCourseDetailsQuery({})
  const { enrollmentCode } = joinCourseData
  const { data: sectionDetailsData } = useStudentSectionDetailsQuery({
    enrollmentCode,
  })
  const { bfsEligible, transferCode } = sectionDetailsData
  const isTransfer = transferCode === enrollmentCode

  // Add enrollment
  const {
    mutate,
    called,
    loading: saving,
    error,
  } = useStudentAddEnrollmentMutation({
    educationPeriod,
    bfsEnrollment: bfsEligible,
    isTransfer,
  })

  // Get enrollments
  const { data: enrollmentsData } = useStudentEnrollmentsQuery({
    educationPeriod,
    otherSkipConditions: !called || (called && saving),
  })

  useAnalyticsStudentRegSuccessEvent({
    complete: called && !saving && enrollmentsData?.courseEnrollments?.length,
    enrollmentDetails: sectionDetailsData,
    enrollments: enrollmentsData?.courseEnrollments,
  })

  useEffect(() => {
    if (
      !called
      && !saving
      && educationPeriod
      && joinCourseData
    ) {
      const { __typename, ...restInput } = joinCourseData
      mutate({
        variables: {
          code: educationPeriod,
          input: { ...restInput },
        },
      })
    }
  }, [ called, saving, educationPeriod, joinCourseData ])

  return (
    <Modal
      elem="SaveEnrollmentModal"
      open={true}
      openAnimation={false}
      closeAnimation={true}
      footer={<FooterActions busy={saving} />}
      shadowRoot
      modalNode
    >
      <Message
        courseName={sectionDetailsData?.courseName}
        error={error}
        loading={saving}
        success={called && !saving}
      />
    </Modal>
  )
}

export default SaveEnrollment
